import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LatestMeasurementsRoutingModule } from './latest-measurements-routing.module';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    LatestMeasurementsRoutingModule
  ]
})
export class LatestMeasurementsModule { }
